<template>
  <f7-page name="car">
    <!-- <f7-navbar title="Автомобиль" back-link-force back-link-url="/" back-link></f7-navbar> -->
    <f7-navbar title="Автомобиль" back-link></f7-navbar>
    <f7-list no-hairlines-md id="carData">
      <f7-list-input label="Марка автомобиля" name="carBrand" :value="form.data[0].attributes.carBrand"
        @input="form.data[0].attributes.carBrand = $event.target.value" type="text" placeholder="Toyota Land Cruiser"
        info="Например, Toyota Land Cruiser" error-message="Укажите марку автомобиля" @focus="errorCarBrand = false"
        :error-message-force="errorCarBrand" clear-button></f7-list-input>
      <f7-list-input label="Госномер" name="stateNumber" :value="form.data[0].attributes.stateNumber.toUpperCase()"
        @input="form.data[0].attributes.stateNumber = $event.target.value"
        error-message="Укажите госномер автомобиля буквами русского алфавита" @focus="errorStateNumber = false"
        :error-message-force="errorStateNumber" type="text" placeholder="А001СС196"
        info="Номер КИРИЛЛИЦОЙ, например, А001СС196" clear-button></f7-list-input>
      <f7-list-input label="Тип кузова" name="category" :value="form.data[0].attributes.category"
        @input="form.data[0].attributes.category = $event.target.value" type="select"
        error-message="Укажите тип кузова автомобиля" @focus="errorBodyType = false"
        :error-message-force="errorBodyType" placeholder="Выберите тип кузова...">
        <option :value="category.id" v-for="(category, index) in categories.data" :key="index">
          {{ category.attributes.title }}
        </option>
      </f7-list-input>
      <f7-list-input label="Цвет" name="color" :value="form.data[0].attributes.color"
        @input="form.data[0].attributes.color = $event.target.value" type="text" placeholder="Черный"
        info="Укажите цвет автомобиля (опционально)" required clear-button></f7-list-input>
    </f7-list>

    <f7-block>
      <f7-row tag="p">
        <f7-button round class="col" @click="checkForm" fill>{{
            btn.text
        }}</f7-button>
        <template v-if="btn.isEnable">
          <f7-button round class="col" @click="deleteCar">Удалить</f7-button>
        </template>
      </f7-row>
    </f7-block>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      errorCarBrand: false,
      errorStateNumber: false,
      errorBodyType: false,
      btn: {
        text:
          this.$f7route.context.car.method == "edit" ? "Сохранить" : "Добавить",
        isEnable: this.$f7route.context.car.method == "edit",
      },
      form: {
        data: [
          {
            type: "cars",
            id: "",
            attributes: {
              carBrand: "",
              stateNumber: "",
              category: "",
              color: "",
            },
          },
        ],
      },
      categories: [],
    };
  },
  methods: {
    checkForm() {
      var errors = [];
      var formData = this.$f7.form.convertToData("#carData");
      console.log(formData);

      if (formData.carBrand == "") {
        this.errorCarBrand = true;
        errors.push("errorCarBrand");
      }

      if (!this.validStateNumber(formData.stateNumber)) {
        this.errorStateNumber = true;
        errors.push("errorStateNumber");
      }

      if (formData.category == "") {
        this.errorBodyType = true;
        errors.push("errorBodyType");
      }
      // for (var i = 0; i < garage.length; i++) {
      //   if (
      //     formData.stateNumber == garage[i].stateNumber &&
      //     this.$f7route.context.car.method != "edit"
      //   ) {
      //     errors.push("errorStateNumberAlreadyHave");
      //     this.$f7.dialog.alert(
      //       `С номером <strong> ${formData.stateNumber}</strong>  уже добавлен автомобиль <strong> ${garage[i].carBrand}</strong> `,
      //       "Ошибка"
      //     );
      //   }
      // }
      if (!errors.length) {
        this.cars("", "GET", "cars");
        if (this.$f7route.context.car.method == "edit") {
          this.editStorage(this.$f7route.context.car.key, formData);
          var toast = this.$f7.toast.create({
            text: `${formData.carBrand} с госномером ${formData.stateNumber} отредактирована.`,
            closeTimeout: 5000,
          });
        } else {
          this.writeStorage(formData);
          var toast = this.$f7.toast.create({
            text: `${formData.carBrand} с госномером ${formData.stateNumber} добавлена в гараж.`,
            closeTimeout: 5000,
          });
        }
        // console.log("this.$f7route.context.car.key");
        // console.log(this.$f7route.context.car.key);

        if (this.$f7route.context.car.key == "-1") {
          console.log("Открыть прайс-лист.");
          this.$f7.views.main.router.navigate("/price/");
        } else {
          toast.open();
          this.$f7router.back("/profile/", { force: true });
        }
      }
    },
    validStateNumber(stateNumber) {
      var re = /^[АВЕКМНОРСТУХ]?\d?\d\d\d[АВЕКМНОРСТУХ][АВЕКМНОРСТУХ]\d\d\d?$/;
      return re.exec(stateNumber);
    },
    writeStorage(formData) {
      var car = {
        data: [
          {
            type: "cars",
            id: String(this.$f7route.context.car.key),
            attributes: {
              carBrand: formData.carBrand,
              stateNumber: formData.stateNumber,
              category: formData.category,
              color: formData.color,
            },
          },
        ],
      };
      this.cars(car, "POST", "cars");
    },
    editStorage(key, formData) {
      var car = {
        data: [
          {
            type: "cars",
            id: String(key),
            attributes: {
              carBrand: formData.carBrand,
              stateNumber: formData.stateNumber,
              category: formData.category,
              color: formData.color,
            },
          },
        ],
      };
      this.cars(car, "PATCH", "cars/" + key);
    },
    deleteCar() {
      var key = this.$f7route.context.car.key;
      var toast = this.$f7.toast.create({
        text: `${this.form.data[0].attributes.carBrand} с госномером ${this.form.data[0].attributes.stateNumber} удалена.`,
        closeTimeout: 5000,
      });
      toast.open();
      this.cars("", "DELETE", "cars/" + key);

      this.$f7router.back("/profile/", { force: true });
      this.cars("", "GET", "cars");
    },
    // getAllCar() {
    //   var garage = JSON.parse(localStorage.getItem("garage"));
    //   if (garage) {
    //     return garage;
    //   } else {
    //     return [];
    //   }
    // },
    // getCar(key) {
    //   this.cars("", "GET", "cars/" + key);
    // },
    cars(cars, method, url = "cars") {
      this.$f7ready((f7) => {
        let that = this;
        let order = that.order;
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/" + url,
          method: method,
          dataType: "json",
          data: cars == "" ? "" : JSON.stringify(cars),
          success: function (data, status) {
            console.log(data);
            if (data.data.length > 0) {
              that.form = data;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
            return false;
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
  },
  created() {
    this.$f7ready((f7) => {
      // Call F7 APIs here
      let that = this;
      let getData = {
        filter: {
          group_id: 0,
        },
      };
      f7.request({
        url: "https://ms.bctip.ru/admin/api/typomojka/v1/categories",
        method: "GET",
        dataType: "json",
        data: getData,
        success: function (data, status) {
          if (data.data != null) {
            that.categories = data;
          }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          let data = JSON.parse(XMLHttpRequest.response);
          if (data.errors != null) {
            data.errors.forEach(function (error) {
              f7.dialog.alert(error.detail, "Ошибка " + error.status);
            });
          } else {
            f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
          }
        },
        beforeSend: function (xhr, settings) {
          xhr.setRequestHeader(
            "authorization",
            "Bearer " + localStorage.getItem("token")
          );
        }, //set tokenString before send
      });
    });
    if (this.$f7route.context.car.method == "edit") {
      this.cars("", "GET", "cars/" + this.$f7route.context.car.key);
    }
    var x = history.back();

    console.log(x);
  },
};
</script>